import React from 'react';
import ReactDOM from 'react-dom';
import { ChallengeManagement } from './features/challenge-management/ChallengeManagement';
import { ChallengeProvider } from './features/challenge-management/context/Challenge';
import { Profile } from './features/profile/Profile';
import { Wrapper } from './common/wrapper';
import { AppProps } from './common/interfaces';
import { People } from './features/people/People';
import { Leaderboard } from './features/leaderboard/Leaderboard';
import { Analytics } from './features/analytics/Analytics';
import { ModeratorActionPanel } from './features/moderator-action/ModeratorActionPanel';

interface ChallengeManagementProps extends AppProps {
  challengeId?: string;
}

export interface AnalyticsProps extends AppProps {
  page: string;
}

export interface ModeratorActionProps extends AppProps {
  postId: string;
  originalLocale?: string;
}

declare global {
  interface Window {
    COMPONENTS: {
      challengeManagementApp: (props: ChallengeManagementProps) => void;
      profileApp: (props: AppProps) => void;
      peopleApp: (props: AppProps) => void;
      analyticsApp: (props: AnalyticsProps, targetNode: ReactDOM.Container) => void;
      leaderboardApp: (props: AppProps) => void;
      moderatorActionApp: (props: ModeratorActionProps, targetNode: ReactDOM.Container) => void;
    };
  }
}

export const ChallengeManagementApp = (props: ChallengeManagementProps) => {
  const challengeId = String(props.challengeId || process.env.WEB_CHALLENGE_ID);

  return (
    <Wrapper {...props}>
      <ChallengeProvider id={challengeId}>
        <ChallengeManagement />
      </ChallengeProvider>
    </Wrapper>
  );
};

export const ProfileApp = (props: AppProps) => (
  <Wrapper {...props}>
    <Profile />
  </Wrapper>
);

export const PeopleApp = (props: AppProps) => (
  <Wrapper {...props}>
    <People />
  </Wrapper>
);

export const AnalyticsApp = (props: AnalyticsProps) => (
  <Wrapper {...props}>
    <Analytics {...props} />
  </Wrapper>
);

export const LeaderboardApp = (props: AppProps) => (
  <Wrapper {...props}>
    <Leaderboard />
  </Wrapper>
);

export const ModeratorActionApp = (props: ModeratorActionProps) => (
  <Wrapper {...props}>
    <ModeratorActionPanel {...props} />
  </Wrapper>
);

const domNode = document.createElement('div');
document.querySelector('#main')?.appendChild(domNode);

window.COMPONENTS = {
  challengeManagementApp: (props: ChallengeManagementProps) => {
    ReactDOM.render(<ChallengeManagementApp {...props} />, domNode);
  },
  profileApp: (props: AppProps) => {
    ReactDOM.render(<ProfileApp {...props} />, domNode);
  },
  peopleApp: (props: AppProps) => {
    ReactDOM.render(<PeopleApp {...props} />, domNode);
  },
  analyticsApp: (props: AnalyticsProps, targetNode) => {
    ReactDOM.render(<AnalyticsApp {...props} />, targetNode);
  },
  leaderboardApp: (props: AppProps) => {
    ReactDOM.render(<LeaderboardApp {...props} />, domNode);
  },
  moderatorActionApp: (props: ModeratorActionProps, targetNode) => {
    ReactDOM.render(<ModeratorActionApp {...props} />, targetNode);
  }
};
